module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/promise_06-c713199528b91ec4c271ac7255b69ed5.png";